<template>
  <div class="container d-flex align-items-center justify-content-center" style="height: 100vh">
    <div class="card">
      <div class="card-body text-center p-5">
        <h1><a :href="getLinkedInURL()">Authenticate LinkedIn</a></h1>
      </div>
    </div>


  </div>
</template>

<script>
import api from '../../api/_services'
export default {
  name: 'linked-in-company-authorization',
  methods: {
    getLinkedInURL () {
      return 'https://www.linkedin.com/oauth/v2/authorization' +
        '?response_type=code' +
        '&client_id=78li6p9r20mslk' +
        '&redirect_uri=' + encodeURIComponent(process.env.ROOT_URL + '/oauth-authorization') +
        '&state=hdoa0389lzlv9bvJ%23J%2988sjwl' +
        '&scope=rw_organization_admin%20r_organization_social'
    }
  },
  beforeMount () {
    if (this.$route.query.code === undefined || this.$route.query.state === undefined) {
      return
    }
    api.authenticateLinkedin(this.$route.query.code, this.$route.query.state, this.$route.query.source)
      .then(() => {})
      .catch(err => { console.log(err) })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/LinkedInCompanyAuthorization.vue